export default __webpack_public_path__ + "static/media/grafema_clivitalbio_09.671aae8b.jpg";